import { TranslationsInterface } from 'translations';

const pt: TranslationsInterface = {
  'banner-cookie':
    'Este website utiliza cookies para garantir o seu correto funcionamento e analisar o tráfego. Ao clicar em "Aceitar todos os cookies", está a concordar com o uso de todos os nossos cookies. Ao clicar em "Rejeitar cookies não essenciais", está a rejeitar os cookies opcionais, mas a permitir o uso dos nossos cookies essenciais. Se desejar saber quais os cookies que está a autorizar ou a rejeitar, clique em',
  'cookie-policy': 'Política de Cookies',
  'cookie-accept': 'Aceitar todos os cookies',
  'cookie-reject': 'Rejeitar cookies não essenciais',
  'splash-window-1':
    'Portal de acesso a informação sobre o sector das comunicações.',
  'splash-window-2': 'Para mais informações, consulte a',
  help: 'Ajuda',
  close: 'Fechar',
  type: 'Tipo',
  themes: 'Temas',
  'turnoff-layers': 'Desligar camadas',
  dock: 'Fixar',
  undock: 'Soltar',
  back: 'Voltar',
  'go-to': 'Ir para',
  'no-data': 'Não há dados',
  compass: 'Repor orientação do mapa',
  'my-location': 'Localização atual',
  'help-menu': 'Ajuda',
  'reset-map-orientation': 'Repor orientação do mapa',

  // Coberturas disponíveis
  'fixed-network': 'Rede fixa',
  'mobile-network': 'Rede móvel',
  satellite: 'Satélite',
  operator: 'Operador',
  technology: 'Tecnologia',
  'download-speed': 'Download (Mbps)',
  'upload-speed': 'Upload (Mbps)',
  'coverage-download': 'Cobertura / Download (Mbps)',
  expand: 'Maximizar',
  collapse: 'Minimizar',
  'fixa-msg':
    'Para as mesmas condições de serviço, a ordem de apresentação dos operadores é aleatória. Consulte mais informação sobre as coberturas disponíveis no menu "Ajuda" ou {{LINK}}clique aqui{{/LINK}}.',
  'movel-msg':
    'A informação disponibilizada é da exclusiva responsabilidade dos operadores. Para as mesmas condições de serviço, a ordem de apresentação dos operadores é aleatória. Consulte mais informação sobre as coberturas disponíveis no menu "Ajuda" ou {{LINK}}clique aqui{{/LINK}}.',
  'satelite-msg':
    'A informação disponibilizada é da exclusiva responsabilidade dos operadores. Para as mesmas condições de serviço, a ordem de apresentação dos operadores é aleatória. Consulte mais informação sobre as coberturas disponíveis no menu "Ajuda" ou {{LINK}}clique aqui{{/LINK}}.',
  'error-load-fixed-network':
    'Não foi possível carregar os resultados da rede fixa!',
  'error-load-mobile-network':
    'Não foi possível carregar os resultados da rede móvel!',
  'error-load-satellite':
    'Não foi possível carregar os resultados de satélite!',

  // Aba identificar
  results: 'Resultados',
  buffer: 'Buffer',
  symbology: 'Simbologia',
  zoom: 'Zoom',
  'select-all': 'Selecionar todos',
  'clear-id': 'Limpar',
  'distance-meters': 'Distância (metros)',
  color: 'Cor',
  transparency: 'Transparência',
  cancel: 'Cancelar',
  apply: 'Aplicar',
  points: 'Pontos',
  lines: 'Linhas',
  polygons: 'Polígonos',
  polygon: 'Polígono',
  'access-here': 'Aceder aqui',
  size: 'Tamanho',
  thickness: 'Espessura',
  outline: 'Contorno',
  fill: 'Preenchimento',

  // Aba pesquisar (há campos repetidos)
  search: 'Pesquisar',
  layer: 'Camada',
  field: 'Campo',
  values: 'Valores',
  'search-placeholder': 'Pesquisar...',
  'select-values-placeholder': 'Selecionar valores...',
  'fixed-distance': 'Distância fixa',
  'interactive-distance': 'Distância interativa',
  line: 'Linha',
  distance: 'Distância',
  meters: 'metros',
  'save-image': 'Guardar Imagem',

  // Widget Modal labels
  'load-data': 'Carregar dados',
  'add-layer': 'Adicionar camadas',
  tools: 'Ferramentas',
  'heat-map': 'Mapa de calor',
  'cluster-map': 'Cluster',
  'coverage-quota': 'Quota de cobertura',
  sketch: 'Anotações',
  edit: 'Editar',
  'property-quota': 'Quota de propriedade',
  'available-coverage': 'Coberturas disponíveis',
  'search-by-drawing': 'Criar área de influência',
  'advanced-search': 'Pesquisa avançada',
  measurement: 'Medição',
  url: 'URL',
  'register-element': 'Criar objeto cadastro',
  'convert-coordinate': 'Coordenadas',
  'clear-section': 'Limpar seleção',
  file: 'Ficheiro',
  geoprocessing: 'Geoprocessamento',
  'map-management': 'Meus mapas',
  'print-map': 'Imprimir',
  occurrence: 'Gestão de ocorrências',
  'initial-view': 'Enquadramento inicial',
  'access-and-services': 'Acessos e serviços',
  'register-event': 'Criar evento',
  add: 'Adicionar',
  complaints: 'Reclamações',
  'map-name': 'Nome do mapa',
  indicators: 'Indicadores',
  'share-map': 'Partilhar mapa',
  share: 'Partilhar',
  'previous-view': 'Enquadramento anterior',
  move: 'Mover',
  'next-view': 'Enquadramento seguinte',
  announcements: 'Anúncios de construção',
  print: 'Imprimir',
  'print-title': 'IMPRIMIR',
  'map-title': 'Título do mapa',
  format: 'Formato',
  'page-size': 'Tamanho da página',
  orientation: 'Orientação',
  'include-legend': 'Incluir legenda',
  navigation: 'Navegação',
  path: 'Traçar trajeto',
  notes: 'Anotações',
  'identify-results': 'Resultados',

  // Widget Modal Log labels
  identify: 'Identificar',

  // Widget Map labels
  scales: 'Escalas',
  coordinates: 'Coordenadas',
  overview: 'Enquadramento',
  'coordinates-list': 'Lista de coordenadas',
  display: 'Representar',
  'projected-coordinates-list': 'Lista de coordenadas Projetadas',
  project: 'Projetar',
  'enter-coordinates': `Introduza as coordenadas aqui, casa coordenada numa linha.
  Exemplo (Y,X):
  39.075690, -8.997064
  41.258176, -8.030267`,
  get: 'Obter',

  // Tool Map labels
  'current-location': 'Localização atual',
  'street-view': 'Street view',
  'zoom-by-window': 'Zoom por janela',
  fullscreen: 'Ecrã inteiro',
  rotation: 'Mover',
  'share-link': 'Partilhar mapa',

  // Tool Map Action labels
  'zoom-in': 'Zoom in',
  'zoom-out': 'Zoom out',
  'initial-viewpoint': 'Enquadramento inicial',
  'previous-viewpoint': 'Enquadramento anterior',
  'next-viewpoint': 'Enquadramento seguinte',
  clear: 'Limpar seleção',
  screenshot: 'Guardar Imagem',

  // Medir
  measure: 'Medir',
  'square-meters': 'Metros quadrados',
  'square-kilometers': 'Quilômetros quadrados',
  radius: 'Raio',
  kilometers: 'Quilômetros',

  //Geoprocessamento
  concentration: 'Concentração',
  aggregation: 'Agregação',

  // Novos termos

  point: 'Ponto',
  polyline: 'Polilinha',
  'freehand-polyline': 'Desenho livre (polilinha)',
  arrow: 'Seta',
  triangle: 'Triângulo',
  rectangle: 'Retângulo',
  circle: 'Círculo',
  ellipse: 'Elípse',
  'freehand-polygon': 'Desenho livre (polígono)',
  text: 'Texto',

  // TOC
  'base-maps': 'Mapa base',
  'spectrum-planning-and-management': 'Planeamento e Gestão de Espectro',
  'spectrum-monitoring-and-supervision': 'Monitorização e Fiscalização',
  coverage: 'Cobertura (Fixa, Móvel e Satélite',
  'postal-services': 'Serviços Postais (SU)',
  'statistics-and-market-analysis': 'Estatísticas e Mercado',
  infrastructures: 'Infraestruturas',
  'general-themes': 'Temas Gerais',
  'external-layers': 'Camadas Externas',

  // Editar - anotações || Edit - Sketch
  'sketch-type': 'Tipo de anotação',
  'point-type': 'Tipo de ponto',
  'point-color': 'Cor do ponto',
  'point-size': 'Tamanho do Ponto',
  'outline-color': 'Cor do contorno',
  'outline-thickness': 'Espessura do contorno',
  'line-type': 'Tipo de linha',
  'fill-color': 'Cor do preenchimento',
  'text-size': 'Tamanho do texto',
  'text-color': 'Cor do texto',
  draw: 'Desenhar',
  'delete-all': 'Apagar todas',
  delete: 'Deletar',
  square: 'Quadrado',
  diamond: 'Diamante',
  cross: 'Cruz',
  solid: 'Sólido',
  dash: 'Traço',
  dot: 'Ponto',
  'dash-dot': 'Traço-ponto',
  'long-dash-dot-dot': 'Traço-ponto-ponto-longo',
  'line-color': 'Cor da linha',
  'drop-or-browse': 'Largar ou procurar',
  'supported-file-formats': 'Ficheiros suportados',

  // Mensagens
  'failed-load-location': 'Não foi possível carregar a localização atual!',
  'select-location': 'Selecione no mapa o local pretendido',
  warning: 'Atenção',
  'select-location-or-enter-address':
    'Selecione no mapa o local pretendido ou indique a sua morada no “Ir para”.',
  'failed-load-data': 'Não foi possível carregar os dados',
  'failed-load-page': 'Não foi possível carregar a página!',
  'not-authenticated': 'Não autenticado!',
  'failed-generate-link': 'Não foi possível gerar o link!',
  'failed-load-WKID-list': 'Não foi possível carregar a lista de WKIDs!',
  'failed-load-favorite-map': 'Não foi possível carregar o mapa favorito!',
  'map-not-found': 'Mapa não encontrado!',
  'failed-load-map': 'Não foi possível carregar o mapa!',
  'failed-export-image': 'Não foi possível exportar a imagem!',
  'failed-upload-file': 'Não foi possível fazer o upload do arquivo!',
  'layer-added-successfully': 'Camada adicionada com sucesso',
  'failed-load-layer': 'Não foi possível carregar a camada!',
  'no-route-found': 'Nenhum trajeto encontrado',
  'unable-calculate-routes': 'Não foi possível encontrar trajetos!',
  'invalid-coordinates': 'Coordenadas inválidas!',
  'failed-project-coordinates': 'Não foi possível projetar as coordenadas!',
  'fill-required-fields-correctly': 'Preencha os campos corretamente!',
  'event-saved-successfully': 'Evento gravado com sucesso',
  'failed-save-event': 'Não foi possível gravar o evento!',
  'upload-completed-successfully': 'Upload realizado com sucesso',
  'no-records-found': 'Nenhum registo encontrado',
  'failed-fetch-data': 'Não foi possível trazer os dados!',
  'export-large-items':
    'Para exportação de extensões, áreas ou número de elementos selecionados superior, contatar a equipa SIG',
  'failed-export-data': 'Não foi possível exportar os dados!',
  'failed-load-attachments': 'Não foi possível carregar os anexos!',
  'unable-retrieve-current-location':
    'Não foi possível recuperar a localização atual!',
  'process-created-successfully': 'Processo criado com sucesso',
  'failed-create-process': 'Não foi possível criar o processo!',
  'only-zip-allowed': 'Somente arquivos .zip são permitidos!',
  'uploaded-successfully': 'carregado com sucesso',
  'failed-read-file': 'Não foi possível ler o arquivo!',
  'map-loaded-successfully': 'Mapa carregado com sucesso',
  'map-shared-successfully': 'Mapa compartilhado com sucesso',
  'failed-share-map': 'Não foi possível compartilhar o mapa!',
  'map-imported-successfully': 'Mapa importado com sucesso',
  'failed-import-map': 'Não foi possível importar o Mapa!',
  map: 'Mapa',
  'marked-favorite-successfully': 'marcado como favorito com sucesso',
  'failed-to': 'Não foi possível',
  'mark-map-as-favorite': 'marcar o mapa como favorito!',
  'map-deleted-successfully': 'Mapa apagado com sucesso',
  'failed-delete-record': 'Não foi possível apagar o registo!',
  'map-saved-successfully': 'Mapa salvo com sucesso',
  'failed-save-data': 'Não foi possível salvar os dados!',
  'failed-download-attachment':
    'Não foi possível realizar o download do anexo!',
  'failed-load-incident-statuses':
    'Não foi possível carregar os status de ocorrência!',
  'failed-load-incident-types':
    'Não foi possível carregar os tipos de ocorrência!',
  'incident-status-updated-successfully':
    'Estado da ocorrência alterado com sucesso!',
  'failed-update-incident-status':
    'Não foi possível alterar o status da ocorrência!',
  'select-area': 'Selecione uma área!',
  'incident-saved-successfully': 'Ocorrência gravada com sucesso',
  'failed-save-incident': 'Não foi possível gravar a ocorrência!',
  'failed-load-entities': 'Não foi possível carregar as entidades!',
  'failed-fetch-incident-data':
    'Não foi possível trazer os dados da ocorrência!',
  'failed-load-results': 'Não foi possível carregar os resultados!',
  'printing-failed': 'Não foi possível imprimir, tente novamente!',
  'data-saved-successfully': 'Dados salvos com sucesso',
  'no-features-found': 'Nenhum objeto encontrado',
  'filter-deleted-successfully': 'Filtro apagado com sucesso',
  'failed-delete-history-filter':
    'Não foi possível apagar o filtro do histórico!',
  'failed-load-history': 'Não foi possível carregar o histórico!',
  'failed-load-documents': 'Não foi possível carregar os documentos!',
  'search-saved-successfully': 'Pesquisa guardada com sucesso',
  'failed-save-search': 'Não foi possível salvar a pesquisa!',
  'link-copied-clipboard': 'Link copiado para a área de transferência',
  'map-link-generated-successfully': 'Link do mapa gerado com sucesso',
  'unable-access-data': 'Não é possível acessar os dados',
  'you-are-not-authenticated': 'Você não está autenticado!',
  sucess: 'Sucesso',
  error: 'Erro',
  alert: 'Alerta',
  'light-gray-canvas': 'Fundo Cinza Claro',
  'dark-gray-canvas': 'Fundo Cinza Escuro',
  'imagery-hybrid': 'Híbrido de Imagens',
  'national-geographic-map': 'Mapa Estilo National Geographic',
  'navigation-map': 'Navegação',
  oceans: 'Oceanos',
  streets: 'Base de Ruas',
  'terrain-with-labels': 'Terrenos com Rótulos',
  topographic: 'Topográfico',
  example: 'exemplo',
  copy: 'Copiar',
  includeNull: 'Incluir valores nulos',
};

export default pt;
